// Immagini auto-ospitate in /public/images — nessuna CDN esterna (GDPR friendly).
// sizedImg resta per compatibilità con le immagini dei progetti caricate dall'admin:
// per i percorsi locali (o /api/uploads) restituisce l'URL invariato.
export const sizedImg = (url, w = 1000) =>
  url && url.startsWith("http") ? (url.includes("?") ? `${url}&w=${w}` : `${url}?w=${w}`) : url;

export const IMG = {
  hero: "/images/hero.jpg",
  // Impermeabilizzazione poliurea — roof waterproofing
  waterproofing: "/images/waterproofing.jpg",
  // Coibentazione poliuretano — wall insulation
  insulation: "/images/insulation.jpg",
  // Team / chi siamo
  team: "/images/chi-siamo-team.jpg",
  // Ristrutturazioni — casa residenziale
  villa: "/images/villa.jpg",
  // Piscine — casa con piscina
  pool: "/images/pool.jpg",
  // Efficientamento energetico — pannelli fotovoltaici
  solar: "/images/solar.jpg",
  // Pareti ventilate — facciata moderna rivestita
  facade: "/images/facade.jpg",
  // Rivestimenti protettivi anticorrosivi — lavorazione su struttura metallica
  steel: "/images/steel.jpg",
  // Restauro conservativo — edificio storico in pietra
  stone: "/images/stone.jpg",
  // Finiture e rivestimenti — interni curati
  interior: "/images/interior.jpg",
};
